type TLanguageOptionVariant = 'launcher' | 'webpages'

type TLanguageOption<Locale> = {
  locale: Locale
  label: string
}

type TLanguageOptions<Locale extends string> = Record<Locale, string>

// Removing es, fr and jp as an option for now. If they need to be added back in,
// uncomment the import and replace TTempSupportedLocale with TSupported Locale again.
enum TempSupportedLocale {
  German = 'de',
  English = 'en',
  Chinese = 'zh',
}

export const launcherLanguageOptions: TLanguageOptions<
  TempSupportedLocale | 'fr' | 'ja' | 'ko'
> = {
  de: 'Deutsch (German)',
  en: 'English',
  // es: 'Español',  
  zh: '简体中文 (Simplified Chinese)',
  fr: 'Français (French) - (for supported content only)',
  ja: '日本語 (Japanese) - (for supported content only)',
  ko: '한국어 (Korean) - (for supported content only)',
}

export const webpagesLanguageOptions: TLanguageOptions<TempSupportedLocale> = {
  de: 'Deutsch',
  en: 'English',
  // es: 'Español',
  // fr: 'Français',
  // ja: '日本語',
  zh: '简体中文',
}

const optionsVariantMap = {
  launcher: launcherLanguageOptions,
  webpages: webpagesLanguageOptions,
}

function getLanguageMap<K extends TLanguageOptionVariant>(
  variant: K,
): typeof optionsVariantMap[K] {
  return optionsVariantMap[variant]
}

export function getLanguageOptions<K extends TLanguageOptionVariant>(
  variant: K,
): TLanguageOption<keyof typeof optionsVariantMap[K]>[] {
  const optionMap = getLanguageMap(variant)

  return Object.entries(optionMap).map(([locale, label]) => ({
    label,
    locale: locale as TempSupportedLocale,
  }))
}

export function getLanguageLabel<K extends TLanguageOptionVariant>(
  variant: K,
  locale: keyof typeof optionsVariantMap[K],
): typeof optionsVariantMap[K][keyof typeof optionsVariantMap[K]] {
  const optionMap = getLanguageMap(variant)

  return optionMap[locale]
}
